import { Close } from "@mui/icons-material";
import { Chip, useTheme } from "@mui/material";
import { FC } from "react";

export interface RemovableChipProps {
  label: string;
  onDelete?: () => void;
  disabled?: boolean;
  color?: string;
  fontWeight?: number;
}

export const RemovableChip: FC<RemovableChipProps> = ({
  label,
  onDelete,
  disabled = false,
  color,
  fontWeight,
}) => {
  const theme = useTheme();

  return (
    <Chip
      deleteIcon={<Close sx={{ fontSize: 16 }} />}
      disabled={disabled}
      label={label}
      onDelete={onDelete}
      size="medium"
      sx={{
        backgroundColor: theme.colors.grey,
        color: color ?? theme.colors.text[6],
        fontWeight: fontWeight,
        paddingRight: "8px",
        "& .MuiChip-deleteIcon": {
          color: theme.colors.secondary[5],
          ml: "1px",
          "&:hover": {
            color: theme.colors.secondary[6],
          },
        },
      }}
      variant="filled"
    />
  );
};
